import React, { Component } from 'react';

import { Field } from 'redux-form';
import { Col, Row, FormGroup, ControlLabel } from 'react-bootstrap';
import Select from 'react-select';
import selectTheme from '../../../../helpers/selectTheme';
import styled from 'styled-components';
import {
  FormGroupInput,
  NameFields,
  FormGroupBooleanButtonGroup,
} from '../../../../common/form/components/components';
import { required } from 'redux-form-validators';

const isRequired = required({ message: 'Field is Required' });
const Director = styled.div`
  padding: 10px;
  margin-bottom: 10px;
  background: linear-gradient(to right, #3f7898, #49bed0);
`;

const NameInput = ({ input, required }) => {
  return (
    <FormGroup key={input.name}>
      <Col sm={5}>
        <ControlLabel>
          <span style={{ color: 'white' }}>
            Names of Directors / Partners / Proprietor
          </span>
        </ControlLabel>
      </Col>
      <Col sm={7}>
        <Field
          name={input.name}
          component={NameFields}
          incTitle={true}
          isChild={false}
          required={required}
        />
      </Col>
    </FormGroup>
  );
};

export default class Directors extends Component {
  componentDidMount() {
    const { fields } = this.props;
    if (fields.length === 0) {
      fields.push();
    }
  }
  handleDirectorCountChange(option) {
    const { fields, removeDirectors } = this.props;
    const noOfDirectors = option.value;
    if (noOfDirectors > fields.length) {
      for (let i = fields.length; i < noOfDirectors; i++) {
        fields.push();
      }
    }
    if (noOfDirectors < fields.length) {
      removeDirectors(noOfDirectors, fields.length);
      fields.splice(noOfDirectors, fields.length - 1);
    }
  }

  render() {
    const { fields } = this.props;
    return (
      <div key={'directorsArray'}>
        <Row>
          <Col sm={12}>
            <FormGroup>
              <Col sm={5}>
                <ControlLabel>Number of Directors, Partners and Proprietors</ControlLabel>
              </Col>
              <Col sm={7}>
                <Select
                  theme={(theme) => selectTheme(theme)}
                  options={noOfDirectorOptions}
                  value={noOfDirectorOptions.find((option) => {
                    return option.value === fields.length;
                  })}
                  onChange={(option) => this.handleDirectorCountChange(option)}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>

        {fields.map((insured, index) => {
          return (
            <Director key={index}>
              <Row key={index}>
                <Col sm={12}>
                  <Field
                    name={`data.attributes.metadata.directors[${index}]`}
                    component={NameInput}
                    required={true}
                  />
                </Col>
              </Row>

              <Field
                name={`data.attributes.metadata.directors[${index}].position_and_year`}
                colSize={7}
                component={FormGroupInput}
                labelSize={5}
                label={
                  <span style={{ color: 'white' }}>Position & Year of appointment</span>
                }
                validate={isRequired}
              />
              <Field
                name={`data.attributes.metadata.directors[${index}].individual_fca_number`}
                colSize={7}
                component={FormGroupInput}
                labelSize={5}
                validate={isRequired}
                label={<span style={{ color: 'white' }}>Individual FCA Number</span>}
              />

              <Field
                name={`data.attributes.metadata.directors[${index}].actively_involved.answer`}
                component={FormGroupBooleanButtonGroup}
                label={<span style={{ color: 'white' }}>Actively involved?</span>}
                labelSize={5}
                colSize={5}
                validate={isRequired}
                inline
                options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
              />
            </Director>
          );
        })}
      </div>
    );
  }
}

const noOfDirectorOptions = [
  { value: 1, label: 'One' },
  { value: 2, label: 'Two' },
  { value: 3, label: 'Three' },
  { value: 4, label: 'Four' },
  { value: 5, label: 'Five' },
  { value: 6, label: 'Six' },
];
